var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.series
    ? _c("Card", { staticClass: "series-item clickable" }, [
        _c(
          "div",
          { staticClass: "card-header series-item__header typography--body-2" },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm.getGradeLabel(_vm.series)) +
                " " +
                _vm._s(_vm.getSubjectLabel(_vm.series)) +
                "\n  "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "card-block" }, [
          _c(
            "div",
            {
              staticClass: "card-title series-item__title typography--body-1",
              attrs: { title: _vm.series.name }
            },
            [_vm._v("\n      " + _vm._s(_vm.series.name) + "\n    ")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "card-text" }, [
            _c(
              "small",
              {
                staticClass:
                  "text-muted typography--caption typography--color-secondary"
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("publishers.series.chapter_count", {
                        cnt: _vm.series.chapters_count
                      })
                    ) +
                    "\n      "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "series-item__cover-img-thumb",
          style: _vm.coverImageStyle
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a6383d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a6383d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/components/SeriesItem.vue
// module id = eBP1
// module chunks = 1